import React, { Component } from 'react';
import { Route, Switch } from 'react-router-dom';
import app from '../../../plugins/routes/app';
import { connect } from 'react-redux';

import List from "./Contact/ContactList"

class Contact extends Component {

    render() {
        let trips = app.routes.find(x => x.name === 'contacts');
        return (
            <Switch>
                <Route exact path="/app/contacts" component={List} />
                {trips.routes.map((route, key) => {
                    return <Route
                        path={`${app.path}${trips.path}${route.path}`}
                        meta={route.meta}
                        component={route.component}
                        key={key}
                    />;
                })}
            </Switch>
        )
    }
}

const mapStateToProps = ({ account }) => ({ ...account });
export default connect(mapStateToProps)(Contact);


// WEBPACK FOOTER //
// ./src/components/App/Views/Contact.js